module.exports = __webpack_public_path__ + "static/media/g3.e4b218cb.jpg";